// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__197DX","signatureButtonsRight":"ModalSign_signatureButtonsRight__3aII2"};